import React, { memo, useMemo } from "react";
import { Button } from "../ui/button";

const ErrorState = memo(
  ({
    error,
    onRetry,
    title = "Erreur lors du chargement",
    className = "p-4 text-sm text-red-500 bg-red-50 rounded",
  }) => {
    const errorMessage = useMemo(() => {
      if (typeof error === "string") return error;
      return (
        error?.data?.error ||
        error?.error ||
        error?.message ||
        "Une erreur inattendue s'est produite"
      );
    }, [error]);

    const retryButton = useMemo(() => {
      return onRetry ? (
        <Button onClick={onRetry} variant="outline" size="sm" className="mt-3">
          Réessayer
        </Button>
      ) : null;
    }, [onRetry]);

    return (
      <div className={className}>
        <div className="mb-1 font-medium">{title}</div>
        <div className="mb-2">{errorMessage}</div>
        {retryButton}
      </div>
    );
  }
);

export default ErrorState;
